import React from 'react';

/**
 * ModuleContainer - Contenedor visual para secciones/módulos
 * 
 * @param {string} variant - 'default', 'fichas', 'cotizaciones', 'crm', 'aliados', 'vendedores', 'admin'
 * @param {boolean} noPadding - Sin padding interno (default: false)
 * @param {string} className - Clases adicionales
 */
export const ModuleContainer = ({
  children,
  variant = 'default',
  noPadding = false,
  className = ''
}) => {
  const variants = {
    default: {
      container: 'bg-white border-slate-200',
      accent: 'border-l-slate-400'
    },
    fichas: {
      container: 'bg-slate-50 border-slate-200',
      accent: 'border-l-slate-500'
    },
    cotizaciones: {
      container: 'bg-sky-50/50 border-sky-100',
      accent: 'border-l-sky-500'
    },
    crm: {
      container: 'bg-emerald-50/50 border-emerald-100',
      accent: 'border-l-emerald-500'
    },
    aliados: {
      container: 'bg-amber-50/30 border-amber-200/60',
      accent: 'border-l-amber-500'
    },
    vendedores: {
      container: 'bg-orange-50/40 border-orange-100',
      accent: 'border-l-orange-500'
    },
    clientes: {
      container: 'bg-purple-50/30 border-purple-100',
      accent: 'border-l-purple-500'
    },
    admin: {
      container: 'bg-zinc-50 border-zinc-200',
      accent: 'border-l-zinc-600'
    },
    dark: {
      container: 'bg-zinc-900 border-zinc-800',
      accent: 'border-l-zinc-600'
    }
  };

  const style = variants[variant] || variants.default;
  const padding = noPadding ? '' : 'p-5 md:p-6';

  return (
    <div 
      className={`rounded-xl border shadow-sm border-l-4 ${style.container} ${style.accent} ${padding} ${className}`}
    >
      {children}
    </div>
  );
};

export default ModuleContainer;
